import "../global.css";
import SimpleSlider from "../common/Slider";
import SliderItemAbout from "../common/SliderItemAbout";
import TeamPerson from "../common/TeamPerson";
import CircleSlider from "../common/CircleSlider";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import GradientButtons from "../common/GradientButtons";
import Counter from "../common/Counter";
import { Helmet } from "react-helmet-async";


export default function About() {
  useEffect(() => {
    if (window.location.hash) {
      let newPath = window.location.pathname + window.location.search;
      if (newPath.endsWith('/')) {
        console.log("termina con /", newPath)
        newPath = newPath.slice(0, -1);
        console.log("newPath", newPath)
      }
      window.history.pushState("", document.title, newPath);
    }
  }, []);
  return (
    <div>
      <Helmet>
        <title>About Us | Revolv Space</title>
        <meta
          name="description"
          content="your trusted supplier for ambitious missions"
        />
      </Helmet>
      <div className="relative flex flex-col h-full  mt-20">
        {/* BECOME A REVOLVER Section */}
        <div className="h-full flex flex-col   z-40 ">
          {/* Your content here */}
          <h1 className=" opacity-0 animate-fadeIn delay-0 md:w-5/6 pb-5 mx-12 mt-24  2xl:text-7xl xl:text-7xl lg:text-7xl text-4xl leading-120 tracking-tighter text-left uppercase font-bold text-white dark:text-white  ">
            your trusted supplier <br/>for ambitious missions{" "}
          </h1>
          <div className=" opacity-0 animate-fadeIn delay-1 ml-12 mr-10 uppercase 2xl:text-2xl xl:text-2xl lg:text-2xl text-md  text-white leading-34 tracking-tight text-left max-w-[1000px]">
            we combine cutting-edge technology with an agile development
            approach and a constant feedback loop with the client
          </div>

          <GradientButtons to1="/about/#our-values"  description1=" OUR VALUES" to2="/about/#timeline" description2="OUR STORY" to3="/about/#team" description3="OUR TEAM"/>

        </div>

        {/* ABOUT US */}

        <div  className="flex justify-center pt-72 pb-10">
          <h1  id="our-values" className="opacity-0 animate-fadeIn delay-2 text-3xl md:text-4xl md:text-6xl font-bold text-white text-center uppercase">
            what we stand for
          </h1>
        </div>

        <div
       
          className="relative mb-20  flex items-center justify-center h-full "
          data-aos="zoom-out-up"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600"
        >



            <div className="relative h-full md:h-screen flex flex-col md:flex-row items-start justify-center mx-8 mb-12 my-auto space-y-10 gap-10 md:space-y-0">

            <div className=" flex-1 max-w-xs text-white uppercase space-y-4">
                  <img
                    className="w-24 h-24 mx-auto pb-4"
                    src="TRANSPARENCY.svg"
                    alt=""
                  />
                    <h1 className=" text-3xl text-center font-bold uppercase flex justify-center">TRANSPARENCY</h1>
                                      
                    <div className="text-center">
                                    
                      <p>Our collaboration with you is built on trust: we provide open communication and clear insights at every stage, making us an extension of your team.</p>

                    </div>

                            
                </div>

                <div className=" flex-1 max-w-xs text-white uppercase space-y-4">
                  <img
                    className="w-24 h-24 mx-auto pb-4"
                    src="RESPONSIVENESS.svg"
                    alt=""
                  />
                    <h1 className=" text-3xl text-center font-bold uppercase flex justify-center">PROACTIVENESS</h1>
                                      
                    <div className="text-center mx-auto ">
                                    
                      <p>Your mission's success is our mission: we anticipate challenges, solve problems before they arise, and ensure a seamless journey from our lab to your orbit.</p>
                    </div>

                            
                </div>

              <div className=" flex-1 max-w-xs text-white uppercase space-y-4">
                <img
                    className="w-24 h-24 mx-auto pb-4"
                    src="AGILITY.svg"
                    alt=""
                  />
                    <h1 className=" text-3xl text-center font-bold uppercase flex justify-center">AGILITY</h1>
                                      
                    <div className="text-center">
                                    
                      <p>Our lean approach allows us to deliver high-quality, cost-effective solutions with low lead times, not in spite of them.</p>
                    </div>

                            
                </div>

              <div className=" flex-1 max-w-xs text-white uppercase space-y-4">
                <img
                    className="w-24 h-24 mx-auto pb-4"
                    src="REILABILITY.svg"
                    alt=""
                  />
                    <h1 className=" text-3xl text-center font-bold uppercase flex justify-center">RELIABILITY</h1>
                                      
                    <div className="text-center">
                                    
                      <p>Our hardware is a promise you can count on: we deliver what we say we will, backed by rigorous testing, continuous client involvement, and a commitment to mission success.</p>
                    </div>
                </div>


          </div>







          
        </div>

        {/*TEAM PART*/}
        <div id="team" className="px-10 pt-28">
          <h1 className="text-4xl md:text-6xl font-bold text-white text-center py-4 uppercase">
            meet the revolvers
          </h1>
          <div
            className="grid grid-cols-2 md:grid-cols-4 gap-5 items-start"
            data-aos="zoom-out-up"
            data-aos-offset="400px"
            data-aos-easing="ease-in-sine"
            data-aos-duration="600"
            data-aos-delay="0"

          >
            <TeamPerson 
            imageSrc="/team/Marco.png" 
            name="marco sala" 
            role="CEO" 
            />
            <TeamPerson
              imageSrc="/team/Michal.png"
              name="michal grendysz"
              role="cto"
            />
            <TeamPerson
              imageSrc="/team/Filippo.png"
              name="filippo oggionni"
              role="CCO"
            />
            <TeamPerson
              imageSrc="/team/Aleksander.png"
              name="aleksander fiuk"
              role="coo"
            />

          </div>

          <div className="flex items-center justify-center mt-24 mb-12 "
               data-aos="fade-zoom-in"
               data-aos-offset="100px"
               data-aos-delay="500"
               data-aos-easing="ease-in-sine"
               data-aos-duration="600">
              <img
                src="/team/Team1.jpg"
                className="w-auto md:w-6/12 h-auto rounded-xl"
              alt="sara"/>
          </div>

          <div className="  h-full flex flex-col items-center bg-black bg-opacity-50 z-0 my-20">
            <div className=" grid grid-cols-1 md:grid-cols-2 gap-48 sm:mt-0 text-white">
              <Counter
                type="custom"
                start={0}
                end={30}
                unit="+"
                customLabel="Team members"
                upperText=""
              />
              <Counter
                type="custom"
                start={0}
                end={10}
                unit=""
                customLabel="nationalities"
                upperText=""
              />
            </div>
          </div>


        </div>







        <div className="flex items-center w-full ">
              <div className="grid md:grid-cols-4 text-white w-full mx-5">
                <div className="md:col-span-4 flex justify-center pb-16">
                  <h1 className="text-4xl md:text-6xl font-bold uppercase ">Experience</h1>
                </div>
                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/1.png"
                      alt="airbus"
                    />
                  </div>
                </div>
                
                
                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="400" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/2.png"
                      alt="esa"
                    />
                  </div>
                </div>
                
                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="500" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/3.png"
                      alt="alenia"
                    />
                  </div>
                </div>

                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="500" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/3.1.png"
                      alt="moog"
                    />
                  </div>
                </div>

                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/4.png"
                      alt="dawn"
                    />
                  </div>
                  
                </div>
                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/5.png"
                      alt="creotech"
                    />
                  </div>
                  
                </div>
                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/6.png"
                      alt="satrev"
                    />
                  </div>
                  
                </div><div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/7.png"
                      alt="delft"
                    />
                  </div>

                </div>

                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/8.png"
                      alt="POLITO"
                    />
                  </div>

                </div>

                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/9.png"
                      alt="POLIMI"
                    />
                  </div>

                </div>


                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/10.png"
                      alt="Sron"
                    />
                  </div>

                </div>


                <div className="col-span-1 lg:my-8 my-4 flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-32 md:h-10 sm:h-12 md:h-64 w-auto"
                      src="/about_icons/experience/11.png"
                      alt="hyperion"
                    />
                  </div>

                </div>

              </div>
            </div>
        









        <div id="timeline" className="px-10 md:pt-40">
          <h1 className="text-3xl md:text-6xl  font-bold text-white text-center py-16 uppercase">
            How We've (R)evolved
          </h1>

          <div  data-aos="zoom-in-out"
          data-aos-offset="200"
          data-aos-easing="ease-in-sine"
          data-aos-duration="600">
          <CircleSlider></CircleSlider>

          </div>
        </div>

        {/* ADVISORS */}
        <div className="flex flex-col  relative space-y-10 pt-20">


          <div className="flex flex-col  relative  mt-10">
            <div className="flex items-center w-full ">
              <div className="grid grid-cols-4 text-white w-full mx-24 gap-10">
                <div className="col-span-4 flex justify-center pb-16">
                  <h1 className="text-4xl md:text-6xl font-bold uppercase ">Advisors</h1>
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <img
                      className="object-contain h-auto w-auto"
                      src="/advisors/1.svg"
                      alt="IAN CHRISTIE"
                  />
                </div>

                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <img
                      className="object-contain h-auto w-auto"
                      src="/advisors/2.svg"
                      alt="ANDREA SASSO"
                  />
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <img
                      className="object-contain h-auto w-auto"
                      src="/advisors/3.svg"
                      alt="MACHIEL DEN OUDEN"
                  />
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <img
                      className="object-contain h-auto w-auto"
                      src="/advisors/4.svg"
                      alt="ANDREA BENNETTI"
                  />
                </div>

















              </div>
            </div>
          </div>
        </div>

        {/* SUPPORTERS */}
        <div className="flex flex-col  relative space-y-10 pt-20">


          <div className="flex flex-col  relative  mt-10">
            <div className="flex items-center w-full ">
              <div className="grid grid-cols-4 text-white w-full mx-24 gap-10">
                <div className="col-span-4 flex justify-center pb-16">
                  <h1 className="text-4xl md:text-6xl font-bold uppercase ">Supporters</h1>
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="300" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/new/Logo - ESA BIC Noordwijk - White.svg"
                      alt="ESA BIC"
                    />
                  </div>
                </div>
                
                
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center "  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="400" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/new/plug-and-play-logo-blue.451860baa333 copia.svg"
                      alt="plugandplay"
                    />
                  </div>
                </div>
                
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1  my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="500" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/PoloICT_Bando_Metastars-1 1.svg"
                      alt="meta"
                    />
                  </div>
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1  my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/image-6 1.svg"
                      alt="provincie Zuid Holland"
                    />
                  </div>
                  
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/new/TAKEOFF_Logo_NoTag_RGB_color_d0.svg"
                      alt="TakeOff"
                    />
                  </div>
                  
                </div>
                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/new/primo_ventures_.svg"
                      alt="primo"
                    />
                  </div>
                  
                </div><div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-16 w-auto"
                      src="/about_icons/new/Gra-duate.png"
                      alt="graduate"
                    />
                  </div>

                </div>

                <div className="col-span-4 md:col-span-2 lg:md:col-span-1 my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-24 w-auto"
                      src="/about_icons/new/CASSINI.png"
                      alt="CASSINI"
                    />
                  </div>

                </div>

                <div className="col-span-4 md:col-span-2 lg:col-span-1 lg:col-start-2 my-[2rem] flex flex-col items-center"  data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">
                  <div className="flex items-center justify-center w-full h-full">
                    <img
                      className="object-contain h-10 sm:h-12 md:h-32 w-auto"
                      src="/about_icons/new/CEIP.png"
                      alt="CEIP"
                    />
                  </div>

                </div>

                <div className="col-span-4 md:col-span-2 lg:col-span-1 my-[2rem] flex flex-col items-center"
                     data-aos="fade-zoom-in" data-aos-offset="200" data-aos-delay="600"
                     data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-once="true">

                  <div className="flex items-center justify-center w-full h-full">
                    <img
                        className="object-contain h-24 sm:h-32 md:h-48 lg:h-56 w-auto"
                        src="/about_icons/new/SPACEFOUNDERS.png"
                        alt="spacefounders"
                    />
                  </div>

                </div>


              </div>
            </div>

            <div className="flex items-center justify-center pt-20">
            <Link to="https://careers.revolvspace.com/" replace>
              <button
                  className="rounded-full w-auto h-12 font-bold text-center text-white px-8 transform transition-transform duration-200 hover:scale-110"
                style={{
                  background:
                    "linear-gradient(90deg, #00858F 0%, #E6007E 100%)",
                }}
              >
                JOIN OUR TEAM
              </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
